import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SidebarLayout from "./SidebarLayout.jsx";
import { ROUTES } from "../../constants/routes.js";
import {
  selectRecentTasks,
  selectRecentTasksLoaded,
} from "../../store/slices/recentTasksSlice.js";
import HomeIcon from "../Icons/homeIcon.jsx";
import TemplateIcon from "../Icons/templateIcon.jsx";
import ProjectIcon from "../Icons/projectIcon.jsx";
import TriggerIcon from "../Icons/triggerIcon.jsx";
import RelicIcon from "../Icons/relicIcon.jsx";
import MemoryIcon from "../Icons/memoryIcon.jsx";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  // Recent-tasks list — sourced ENTIRELY from the `/task/events/recent`
  // Server-Sent Events stream (opened once on login in ``AppLayout`` via
  // ``useRecentTasksStream``), which writes each snapshot into
  // ``recentTasksSlice``. The old `/task/` GET + interval polling is gone.
  // ``loaded`` stays false until the first frame lands, so the list shows
  // its skeleton during the initial connect.
  const recentTasks = useSelector(selectRecentTasks);
  const recentsLoading = !useSelector(selectRecentTasksLoaded);

  const isActive = (path) => {
    if (path === ROUTES.HOME) return location.pathname === path;
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  const navItems = [
    {
      path: '/roche-claimsos',
      label: 'Roche ClaimsOS',
      icon: <img src="/roche-logo.png" alt="" style={{width:21,height:15,objectFit:'contain'}} />,
      active: isActive('/roche-claimsos'),
    },
    {
      path: ROUTES.HOME,
      label: "Home",
      icon: <HomeIcon size={15} />,
      active: isActive(ROUTES.HOME),
    },
    {
      path: ROUTES.TEMPLATES,
      label: "Templates",
      dataPage: "templates",
      icon: <TemplateIcon size={15} />,
      active: isActive(ROUTES.TEMPLATES),
    },
    {
      path: ROUTES.PROJECTS,
      label: "Projects",
      dataPage: "projects",
      badge: "Soon",
      disabled: true,
      icon: <ProjectIcon size={15} />,
      active: isActive(ROUTES.PROJECTS),
    },
    {
      path: ROUTES.TRIGGERS,
      label: "Triggers",
      dataPage: "triggers",
      icon: <TriggerIcon size={17} />,
      active: isActive(ROUTES.TRIGGERS),
    },
    {
      path: ROUTES.RELICS,
      label: "Relics",
      dataPage: "relics",
      icon: <RelicIcon size={15} />,
      active: isActive(ROUTES.RELICS),
    },
    {
      path: ROUTES.MEMORY,
      label: "Memory",
      dataPage: "memory",
      badge: "Soon",
      disabled: true,
      icon: <MemoryIcon size={15} />,
      active: isActive(ROUTES.MEMORY),
    },
  ];

  // Knowledge Config now lives inside the profile popout (HIQ-11
  // redesign). The numeric suggestions count rides along so the
  // popout entry can still surface pending-review state.
  const footerItems = [];

  return (
    <SidebarLayout
      newTaskPath={ROUTES.TASK}
      onNavigate={navigate}
      navItems={navItems}
      recentTasks={recentTasks}
      recentsLoading={recentsLoading}
      footerItems={footerItems}
    />
  );
}
